<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchValue"
            @update:model-value="$emit('update:search', searchValue)"
            label="Search equipment"
            placeholder="Search by type, manufacturer, model, donor, location, or asset tag..."
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="comfortable"
            clearable
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="typeValue"
            @update:model-value="$emit('update:type', typeValue)"
            :items="equipmentTypes"
            label="Equipment Type"
            variant="outlined"
            density="comfortable"
            clearable
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="statusValue"
            @update:model-value="$emit('update:status', statusValue)"
            :items="statusOptions"
            label="Status"
            variant="outlined"
            density="comfortable"
            hide-details
            multiple
            :menu-props="{ maxHeight: 300 }"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2" size="small" closable @click:close="removeStatus(item.value)">
                {{ item.title }}
              </v-chip>
              <span v-if="index === 2" class="text-grey text-caption">
                (+{{ statusValue.length - 2 }} more)
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
import { ref, watch } from 'vue'

interface Props {
  search?: string
  type?: string
  status?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  search: '',
  type: '',
  status: () => []
})

const emit = defineEmits(['update:search', 'update:type', 'update:status'])

const searchValue = ref(props.search)
const typeValue = ref(props.type)
const statusValue = ref(props.status)

const removeStatus = (value: string) => {
  const newStatus = statusValue.value.filter(s => s !== value)
  statusValue.value = newStatus
  emit('update:status', newStatus)
}

// Equipment type options
const equipmentTypes = [
  { title: 'All Types', value: '' },
  { title: 'Laptop', value: 'laptop' },
  { title: 'Desktop', value: 'desktop' },
  { title: 'Monitor', value: 'monitor' },
  { title: 'Tablet', value: 'tablet' },
  { title: 'Other', value: 'other' }
]

// Status options
const statusOptions = [
  { title: 'Processing', value: 'processing' },
  { title: 'Troubleshooting', value: 'troubleshooting' },
  { title: 'Parts', value: 'parts' },
  { title: 'Available', value: 'available' },
  { title: 'Claimed', value: 'claimed' },
  { title: 'Delivered', value: 'delivered' }
]

watch(() => props.search, (val) => { searchValue.value = val })
watch(() => props.type, (val) => { typeValue.value = val })
watch(() => props.status, (val) => { statusValue.value = val })
</script>

<style scoped>
/* Vuetify components handle all styling */
</style>
